module.exports = __webpack_public_path__ + "2645d227ce2560083d3dd0ace2a76613.png";